import {
  GET_LEAD_STICKY_COLUMNS,
  GET_LEAD_STICKY_COLUMNS_SUCCESS,
  GET_LEAD_STICKY_COLUMNS_ERROR,
  UPDATE_LEAD_STICKY_COLUMNS,
  UPDATE_LEAD_STICKY_COLUMNS_SUCCESS,
  UPDATE_LEAD_STICKY_COLUMNS_ERROR
} from "./actionTypes"

export const getLeadStickyColumns = () => {
  return {
    type: GET_LEAD_STICKY_COLUMNS,
  }
}

export const getLeadStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_LEAD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getLeadStickyColumnsError = error => {
  return {
    type: GET_LEAD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

export const updateLeadStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_LEAD_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateLeadStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_LEAD_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateLeadStickyColumnsError = error => {
  return {
    type: UPDATE_LEAD_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}